/*
 * @Author: wzc
 * @Date: 2023-09-08
 * @LastEditors: wzc
 * 超赛平台 播出单和数据包装页面中共用或者可能共用到的属性和方法
 * @LastEditTime: 2023-09-08
 * 备注： 主要是围绕 themeList_output 组件为主；还有其他一些共用的小组件 （播出单和数据包装的主题相关的操作和接口都在这里）
 */

import {
  https_package_isAddPublicBroadcastItem,
  https_broadcast_postClearBroadcastItems,
  https_package_changeDataItemName,
  https_package_sendPackageItemInfos,
  https_package_downItemPlayerItemData,
  https_package_downItemThemeData,
  https_package_getConfigurationParam,
  https_package_previewPicOrVideo,
  https_package_pushMaterialsItem,
  // https_package_pushBroadcastDaYang,
  // https_package_pushItemThemeDaYang,
  https_package_inSidePushDataDaYang,
} from '@api/platfrom_base_api'
import BackTop from '@components/base/backTop.vue'
import themeList_output from '@components/platfromBase/compreSportsMeet/themeList_output.vue'
import LOAD_SUCCESS_BTN from '@components/base/load_success_btn.vue'
import axios from 'axios'
const { CancelToken, isCanCel } = axios
export default {
  props: {},
  components: {
    BackTop,
    themeList_output,
    LOAD_SUCCESS_BTN,
  },
  watch: {
    // currGroup: {
    //   // 刷新页面可能存在currGroup === null
    //   handler(newVal, oldVal) {
    //     if (newVal && JSON.stringify(oldVal) !== JSON.stringify(newVal)) {
    //       console.debug('themeList_output')
    //       this.init()
    //     }
    //   },
    //   immediate: true,
    // },
    // currSportsDetail: {
    //   handler(newVal, oldVal) {
    //     // console.debug('重新刷新数据1:', newVal, oldVal)
    //     if (JSON.stringify(newVal) != JSON.stringify(oldVal)) {
    //       if (this.currLevelType !== null) {
    //         this.autoLoadThemeList()
    //       }
    //     }
    //   },
    //   //   immediate: true,
    //   deep: true,
    // },
  },
  data() {
    return {
      currSportsDetail: {
        sportsId: null,
        sportsName: null,
        eventId: null,
        eventName: null,
        matchId: null,
      },
      showBackTop: false,
      themeList: null,
      currItemTheme: null,
      editThemeTitle: '',
      cardThemeGraphicsIds: [15, 16],
      pageSizes: [10, 20, 50],
      pageSize: 20,
      currentPage: 1,
      total: 0,
      isDialogFlag: false,
      dialogText: '',
      dialogType: '',
      scrollDomById: 'containerFull_body',
      scrollAreaDom: null,
      apiTimeOutMinNum: 0.5, //单位：分钟；合成接口超时响应时间
      resetTimerId: null,
      optionList: [],
      setOptionGruopTitleKeyArr: ['video', 'picture'],
      setOptionGruopTitleNameArr: ['视频参数配置', '图片参数配置'],
      savePreviewPicArr: [], //图片合成 单个
      savePreviewVideoArr: [], //视频合成 单个
      savePushMaterialsPicArr: [], //推送素材【单个图片】
      savePushMaterialsVideoArr: [], //推送素材【单个视频】
      initCurrPreviewType: 'pic', //初始化 数据包装中【图片|视频】的状态
      saveChooseThemeItemArr: [], //存储 多选主题的dataItemId
    }
  },
  created() {
    this.axiosCancelSource = CancelToken.source()
  },
  beforeDestroy() {
    window.removeEventListener('scroll', () => {
      this.scrollListenerEvent()
    })
  },
  computed: {
    isMediaBroadcastFlag() {
      return (
        this.currTab &&
        this.currTab.themeType === 'media' &&
        this.currThemeType &&
        this.currThemeType.id === 'broadcast'
      )
    },
    isMediaFlag() {
      return this.currTab && this.currTab.themeType === 'media'
    },
  },
  methods: {
    onSubmit(item, type) {
      if (item[`${type}_loadSuccessBtnObj`].loading) return
      if (item[`${type}_loadSuccessBtnObj`].success) {
        if (this.resetTimerId) clearTimeout(this.resetTimerId)
        this.resetState(item, type)
        return
      }

      item[`${type}_loadSuccessBtnObj`] = {
        btnType: 'playing',
        loading: true,
        disabled: true,
        success: false,
        error: false,
        isShowTextIcon: 0,
      }

      setTimeout(() => {
        item[`${type}_loadSuccessBtnObj`] = {
          btnType: 'playing',
          loading: false,
          disabled: false,
          success: true,
          error: false,
          isShowTextIcon: 0,
        }

        this.resetTimerId = setTimeout(() => {
          this.resetState(item, type)
        }, 1 * 1000)
      }, 4 * 1000)
    },
    resetState(item, type) {
      Object.assign(item[`${type}_loadSuccessBtnObj`], {
        btnType: 'start',
        loading: false,
        disabled: false,
        success: false,
        error: false,
        isShowTextIcon: 1,
      })
    },
    _valUnitFormatHandler(val, unit) {
      let data
      if (val === undefined || val === null || val === '' || val === ' ') {
        return '-'
      }
      data = `${val}${unit ? unit : ''}`
      return data
    },
    scrollListenerEvent() {
      const scrollTop = this.scrollAreaDom.scrollTop
      const scrollHeight = this.scrollAreaDom.scrollHeight
      const parentHeightPx = this.scrollAreaDom.offsetHeight
      let direction = this.DIRECTION_ENUM.DOWN
      if (this.beforeScrollTop > scrollTop) {
        direction = this.DIRECTION_ENUM.UP
      }
      // 通过滚动方向判断是触底还是触顶
      // console.debug(
      //   'direction:',
      //   direction,
      //   scrollTop,
      //   parentHeightPx,
      //   scrollHeight,
      //   this.isScrollBottom
      // )

      if (scrollTop > 300) {
        this.showBackTop = true
      } else {
        this.showBackTop = false
      }

      // this.changeMatchLabelFixed(scrollTop, direction)

      if (direction == this.DIRECTION_ENUM.DOWN) {
        // 滚动触底
        if (scrollTop + parentHeightPx + this.threshold >= scrollHeight) {
          console.debug('滚动触底')
          this.isScrollBottom = true
        }
      } else {
        // 滚动到顶部
        this.isScrollBottom = false
        if (scrollTop <= this.threshold) {
          console.debug('滚动到顶部')
        }
      }

      this.beforeScrollTop = this.scrollAreaDom.scrollTop
    },
    goBackTop() {
      if (this.scrollAreaDom) {
        this.scrollAreaDom.scrollTo(0, 0)
      }
    },
    initScroll() {
      if (this.scrollAreaDom) {
        return
      }

      this.beforeScrollTop = 0
      this.threshold = 5
      this.DIRECTION_ENUM = {
        DOWN: 'down',
        UP: 'up',
      }
      // window.addEventListener('resize', () => {
      //   this.onResizeEvent()
      // })
      // this.scrollAreaDom = document.getElementsByClassName(
      //   `${this.scrollDomClassName}`
      // )[0]
      this.scrollAreaDom = document.getElementById(`${this.scrollDomById}`)

      // console.debug(this.scrollAreaDom)
      this.scrollAreaDom.addEventListener('scroll', () => {
        this.scrollListenerEvent()
      })
    },
    cancelBatchChoose_remove() {
      this.isBatchChoose = false
      this.saveChooseThemeItemArr = []
      this.themeList.forEach((themeItem) => {
        themeItem.isChooseAct = false
      })
    },
    openDialog(type, item) {
      console.debug(type, item)
      if (type === 'updateMediaData') {
        //媒体云：【刷新】按钮  不需要弹窗二次确认， 直接执行函数
        this.autoLoadThemeList()
        return
      } else if (['roomRemove'].includes(type)) {
        this.isBatchChoose = true
        this.saveChooseThemeItemArr = []
        this.themeList.forEach((themeItem) => {
          themeItem.isChooseAct = true
          this.saveChooseThemeItemArr.push(themeItem.dataItemId)
        })
        return
      } else if (['refreshPage'].includes(type)) {
        // 播出单【刷新】按钮
        console.debug('刷新页面')
        this.autoLoadThemeList()
        return
      }
      this.dialogType = type
      this.currItemTheme = null
      this.editThemeTitle = ''
      this.isDialogFlag = true
      if (type == 'broacdcast_eidtPlayerItem') {
        this.dialogText = '编辑播出单'
        this.currItemTheme = item
        this.editThemeTitle = item.name
      } else if (type == 'broacdcast_removeItem') {
        this.currItemTheme = item
        let removeActPlayerItem = ''
        if (item.id === this.currGroupOptMap.playerItemId) {
          removeActPlayerItem = `（该播出单为默认分享播出单）`
        }
        this.dialogText = `请确认是否删除【${item.name}】播出单${removeActPlayerItem}`
      } else if (type == 'broacdcast_addPlayerItem') {
        this.dialogText = `创建播出单`
      } else if (type == 'batchChoose_roomRemoveOk') {
        this.dialogText = `请确认是否删除【${this.currRoom.name}】下已选的主题: ${this.saveChooseThemeItemArr.length}条`
      } else if (type == 'batchChoose_removeCancel') {
        this.dialogText = '请确认是否退出批量删除'
      } else if (type == 'broacdcast_produceList') {
        //生成播单
        this.dialogText = `请确认是否全部生成播单`
      } else if (type == 'roomDeleteItem') {
        this.currItemTheme = item
        //删除演播室下单个主题
        this.dialogText = `请确认是否删除【${item.analysisItemName}】该主题`
      } else if (type == 'dataPackage_deleteItem') {
        //删除数据包装播单下单个主题
        this.currItemTheme = item
        this.dialogText = `请确认是否删除【${item.analysisItemName}】该主题`
      } else if (type == 'eidtThemeItemName') {
        //文件命名标题
        this.currItemTheme = item
        this.editThemeTitle = item.analysisItemName
        this.dialogText = `文件命名`
      } else if (type == 'downAllData') {
        //下载这个演播室数据
        this.dialogText = `请确认是否下载全部数据`
      } else if (type == 'themeDownData') {
        // 下载单个数据
        this.currItemTheme = item
        this.dialogText = `请确认是否下载【${item.analysisItemName}】主题数据`
      } else if (type == 'themeDownPic') {
        // 下载单个图片
        this.currItemTheme = item
        this.dialogText = `请确认是否下载【${item.analysisItemName}】主题图片`
      } else if (type == 'productPicOrVideo') {
        // 【合成】按钮
        this.currItemTheme = item
        let title = item.currPreviewType === 'pic' ? '图片' : '视频'
        this.dialogText = `请确认是否合成【${title}】模式下【${item.analysisItemName}】主题（注：生成需要时间，请等待）`
      } else if (type == 'pushMaterialsItem') {
        // 【推送】按钮
        this.currItemTheme = item
        let title = item.currPreviewType === 'pic' ? '图片' : '视频'
        this.dialogText = `请确认是否推送【${item.analysisItemName}】主题下的【${title}】素材`
      } else if (type == 'sendSource') {
        // 全部【推送素材】
        this.currItemTheme = item
        this.dialogText = `请确认是否推送全部素材`
      } else if (type == 'dataPackage_setOption') {
        // 参数配置
        // this.currItemTheme = item
        this.dialogText = '参数配置'
      } else if (type === 'daYangPushDataThemeItem') {
        // 大洋推送单个主题数据
        this.currItemTheme = item
        this.dialogText = `请确认是否推送【${item.analysisItemName}】主题数据`
      } else if (type === 'broacdcast_pushAllDaYange') {
        // 大洋推送某个播出单全部主题数据
        this.dialogText = `请确认是否推送全部主题数据`
      } else {
        this.dialogText = ''
      }
    },
    // openDialog(type, item) { //old version
    //   console.debug(type, item)
    //   if (type === 'updateMediaData') {
    //     //媒体云：【刷新】按钮  不需要弹窗二次确认， 直接执行函数
    //     this.autoLoadThemeList()
    //     return
    //   } else if (['publicRemove', 'roomRemove'].includes(type)) {
    //     this.isBatchChoose = true
    //     this.saveChooseThemeItemArr = []
    //     this.themeList.forEach((themeItem) => {
    //       themeItem.isChooseAct = true
    //       this.saveChooseThemeItemArr.push(themeItem.dataItemId)
    //     })
    //     return
    //   }
    //   this.dialogType = type
    //   this.currItemTheme = null
    //   this.editThemeTitle = ''
    //   this.isDialogFlag = true
    //   if (type == 'batchChoose_publicRemoveOk') {
    //     this.dialogText = `请确认是否删除【公共播单】下已选的主题: ${this.saveChooseThemeItemArr.length}条`
    //   } else if (type == 'batchChoose_roomRemoveOk') {
    //     this.dialogText = `请确认是否删除【${this.currTab.name}】下已选的主题: ${this.saveChooseThemeItemArr.length}条`
    //   } else if (type == 'batchChoose_removeCancel') {
    //     this.dialogText = '请确认是否退出批量删除'
    //   } else if (type == 'import') {
    //     this.dialogText = '请确认是否导入该场比赛所有主题'
    //   } else if (type == 'send') {
    //     this.dialogText = `请确认是否将【${this.currTab.name}】发送播单`
    //   } else if (type == 'publicDeleteItem') {
    //     //删除公共播单下单个主题
    //     this.currItemTheme = item
    //     this.dialogText = `请确认是否删除【${item.analysisItemName}】该主题`
    //   } else if (type == 'roomDeleteItem') {
    //     this.currItemTheme = item
    //     //删除演播室下单个主题
    //     this.dialogText = `请确认是否删除【${item.analysisItemName}】该主题`
    //   } else if (type == 'dataPackage_deleteItem') {
    //     //删除数据包装播单下单个主题
    //     this.currItemTheme = item
    //     this.dialogText = `请确认是否删除【${item.analysisItemName}】该主题`
    //   } else if (type == 'eidtThemeItemName') {
    //     //文件命名标题
    //     this.currItemTheme = item
    //     this.editThemeTitle = item.analysisItemName
    //     this.dialogText = `文件命名`
    //   } else if (type == 'broacdcast_produceList') {
    //     //生成播单
    //     this.dialogText = `请确认是否全部生成播单`
    //   } else if (type == 'downAllData') {
    //     //下载这个演播室数据
    //     this.dialogText = `请确认是否下载全部数据`
    //   } else if (type == 'themeDownData') {
    //     // 下载单个数据
    //     this.currItemTheme = item
    //     this.dialogText = `请确认是否下载【${item.analysisItemName}】主题数据`
    //   } else if (type == 'themeDownPic') {
    //     // 下载单个图片
    //     this.currItemTheme = item
    //     this.dialogText = `请确认是否下载【${item.analysisItemName}】主题图片`
    //   } else if (type == 'productPicOrVideo') {
    //     // 【合成】按钮
    //     this.currItemTheme = item
    //     let title = item.currPreviewType === 'pic' ? '图片' : '视频'
    //     this.dialogText = `请确认是否合成【${title}】模式下【${item.analysisItemName}】主题（注：生成需要时间，请等待）`
    //   } else if (type == 'pushMaterialsItem') {
    //     // 【推送】按钮
    //     this.currItemTheme = item
    //     let title = item.currPreviewType === 'pic' ? '图片' : '视频'
    //     this.dialogText = `请确认是否推送【${item.analysisItemName}】主题下的【${title}】素材`
    //   } else if (type == 'sendSource') {
    //     // 全部【推送素材】
    //     this.currItemTheme = item
    //     this.dialogText = `请确认是否推送【${this.currTab.name}】下的全部素材`
    //   } else if (type == 'dataPackage_setOption') {
    //     // 参数配置
    //     // this.currItemTheme = item
    //     this.dialogText = '参数配置'
    //   } else {
    //     this.dialogText = ''
    //   }
    // },
    async clickThemeBtnArea(type) {
      this.isDialogFlag = false
      window.mixtmtBase_eventBus.$emit('loadingEvent', true)
      if (type == 'batchChoose_roomRemoveOk') {
        // 单个演播单 批量删除
        await this.removeRoomPackageItems(this.saveChooseThemeItemArr, 'batch')
      } else if (type == 'batchChoose_removeCancel') {
        this.cancelBatchChoose_remove()
      } else if (type == 'broacdcast_eidtPlayerItem') {
        // 接口编辑播出单
        await this.postEditBroadcast(this.editThemeTitle, this.currItemTheme.id)
      } else if (type == 'broacdcast_removeItem') {
        await this.removeSwiperItemHandle(this.currItemTheme)
      } else if (type == 'broacdcast_addPlayerItem') {
        // 接口新增新播出单
        this.postCreateBroadcast(this.editThemeTitle)
      } else if (type == 'roomDeleteItem') {
        await this.removeRoomPackageItems(this.currItemTheme)
      } else if (type == 'dataPackage_deleteItem') {
        await this.removeDataPackageItems(this.currItemTheme)
      } else if (type == 'eidtThemeItemName') {
        await this.editDataItemName(this.currItemTheme)
      } else if (type == 'broacdcast_produceList') {
        await this.produceList(this.currItemTheme)
      } else if (type == 'downAllData') {
        await this.downAllData(this.currItemTheme)
      } else if (type == 'themeDownData') {
        await this.themeDownData(this.currItemTheme)
      } else if (type == 'themeDownPic') {
        await this.themeDownPic(this.currItemTheme)
      } else if (type == 'productPicOrVideo') {
        // 【合成】按钮
        this.previewPicOrVideoApi(this.currItemTheme)
        // setTimeout(() => {
        //   console.debug("取消接口访问")
        //   this.axiosCancelSource.cancel('取消接口访问')
        // }, 10 * 1000)
      } else if (type == 'sendSource') {
        // 【素材推送】按钮 全部推送
        // this.previewPicOrVideoApi(this.currItemTheme)
      } else if (type == 'pushMaterialsItem') {
        // 【推送】按钮 推送单个主题素材
        this.pushMaterialsItemApi(
          this.currItemTheme,
          this.currItemTheme.currPreviewType
        )
      } else if (type === 'daYangPushDataThemeItem') {
        this.daYangPushDataThemeItem('http://127.0.0.1:9029', 'themeItem')
        // this.daYangInsidePushData(
        //   `${this.daYangThemeBtnArr.room[0].pushPrefix}/dataitem_data/tennis`
        // )
      } else if (type === 'broacdcast_pushAllDaYange') {
        this.daYangPushDataPlayerList(
          'http://127.0.0.1:9029',
          'pushAllPlayerList'
        )
        // this.daYangInsidePushData(
        //   `${this.daYangThemeBtnArr.room[0].pushPrefix}/broadcast_data/tennis`
        // )
      } else {
        console.debug('dialogType的值不存在')
      }
      window.mixtmtBase_eventBus.$emit('loadingEvent', false)
    },
    cancelDialog() {
      // 清空
      this.isDialogFlag = false
      this.dialogType = ''
      this.currItemTheme = null
      this.editThemeTitle = ''
    },
    removeSingleTheme(item, currTabId) {
      if (currTabId == 'dataPackage') {
        this.openDialog('dataPackage_deleteItem', item)
      } else {
        this.openDialog('roomDeleteItem', item)
      }
    },
    eidtSingleTheme(item) {
      this.openDialog('eidtThemeItemName', item)
    },
    downDataSingleTheme(item) {
      this.openDialog('themeDownData', item)
    },
    clickDaYangPushDataThemeItem(item, currUserObj) {
      console.debug('currUserObj:', currUserObj)
      this.openDialog('daYangPushDataThemeItem', item)
    },
    downDataPicTheme(item) {
      this.openDialog('themeDownPic', item)
    },
    productPicOrVideo(item) {
      // 合成图片或者视频
      console.debug(item)
      if (
        (item.currPreviewType === 'pic' && item.pictureCreateStatus === 2) ||
        (item.currPreviewType === 'video' && item.videoCreateStatus === 2)
      ) {
        // 状态是 合成中时，不允许再合成
        return
      }
      this.openDialog('productPicOrVideo', item)
    },
    pushMaterialsItem(item) {
      // 推送主题单个素材
      this.openDialog('pushMaterialsItem', item)
    },
    themeChangeType(item, type) {
      // 切换主题是图片还是视频展示
      console.debug('themeItem:', item)
      item.currPreviewType = type
    },
    handleSizeChange(val) {
      console.debug(`每页 ${val} 条`)
      window.mixtmtBase_eventBus.$emit('loadingEvent', true)
      this.currentPage = 1
      this.cancelBatchChoose_remove()
      this.autoLoadThemeList()
      window.mixtmtBase_eventBus.$emit('loadingEvent', false)
    },
    handleCurrentChange(val) {
      console.debug(`当前页: ${val}`)
      this.currentPage = val
      window.mixtmtBase_eventBus.$emit('loadingEvent', true)
      this.autoLoadThemeList()
      window.mixtmtBase_eventBus.$emit('loadingEvent', false)
    },
    async getConfigurationParam() {
      // 媒体云 获取参数配置类型 接口
      await https_package_getConfigurationParam(this.axiosBaseUrl, this.$axios)
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            this.optionList = res.data.map((one) => {
              if (one.twos) {
                one.twos.map((two) => {
                  if (two.threes) {
                    two.checkList = []
                  }
                  return two
                })
              }
              return one
            })
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },

    async pushMaterialsItemApi(themeItem, type) {
      // 单个【推送】接口
      if (
        themeItem[`${type}_loadSuccessBtnObj`].loading ||
        themeItem[`${type}_loadSuccessBtnObj`].success ||
        themeItem[`${type}_loadSuccessBtnObj`].disabled
      )
        // 推送中 || 推送刚完成时的对勾 || 不可点击
        return

      themeItem[`${type}_loadSuccessBtnObj`] = {
        btnType: 'playing',
        loading: true,
        disabled: false,
        success: false,
        isShowTextIcon: 0,
      }

      console.debug(themeItem)
      const query = {
        dataItemId: themeItem.dataItemId,
        packageId:
          this.currTab && this.currTab.id
            ? this.currTab.id === 'all'
              ? 0
              : this.currTab.id
            : 0,
        pushType:
          themeItem.currPreviewType === 'video'
            ? themeItem.currPreviewType
            : 'picture',
      }
      if (themeItem.currPreviewType === 'pic') {
        this.savePushMaterialsPicArr.push(themeItem.dataItemId)
      } else if (themeItem.currPreviewType === 'video') {
        this.savePushMaterialsVideoArr.push(themeItem.dataItemId)
      }
      await https_package_pushMaterialsItem(
        this.axiosBaseUrl,
        this.$axios,
        query,
        {
          // cancelToken: new CancelToken(function executor(c) {
          //   // 参数 c 也是个函数
          //   _this.cancelToken.push(c)
          // }),
          cancelToken: this.axiosCancelSource.token,
          timeout: this.apiTimeOutMinNum * 60 * 1000, //重设请求超时时间
        }
      )
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            this.updatePushMaterialsItem(themeItem.currPreviewType, res.data)
            let typeText = themeItem.currPreviewType === 'pic' ? '图片' : '视频'
            this.$message({
              showClose: true,
              message: `【${themeItem.dataItemName}】-${typeText}推送完成`,
              type: 'success',
            })
            themeItem[`${type}_loadSuccessBtnObj`] = this.initSetPushBtnObj(6)
            setTimeout(() => {
              themeItem[`${type}_loadSuccessBtnObj`] = this.initSetPushBtnObj(3)
            }, 1 * 1000)
            this.initRefreshEvent()
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              themeItem[`${type}_loadSuccessBtnObj`] = this.initSetPushBtnObj(7)
              setTimeout(() => {
                themeItem[`${type}_loadSuccessBtnObj`] =
                  this.initSetPushBtnObj(4)
              }, 1 * 1000)
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
          // if (this.isCancel(err)) {
          //   // 获取 取消请求 的相关信息
          //   console.debug('Request canceled', thrown.message)
          // } else {
          //   // 处理其他异常
          // }
          themeItem[`${type}_loadSuccessBtnObj`] = this.initSetPushBtnObj(7)
          setTimeout(() => {
            themeItem[`${type}_loadSuccessBtnObj`] = this.initSetPushBtnObj(4)
          }, 1 * 1000)
        })
    },
    async previewPicOrVideoApi(themeItem) {
      // 单个【合成】接口
      console.debug(themeItem)
      let type = ''
      if (themeItem.currPreviewType === 'pic') {
        type = 'genImg'
      } else if (themeItem.currPreviewType === 'video') {
        type = 'genVideo'
      } else {
        console.debug('没有找到合成的模式')
        return
      }
      const query = {
        type,
        dataItemId: themeItem.dataItemId,
        packageId:
          this.currTab && this.currTab.id
            ? this.currTab.id === 'all'
              ? 0
              : this.currTab.id
            : 0,
      }
      if (themeItem.currPreviewType === 'pic') {
        themeItem.picPreview_loadSuccessBtnObj = this.initSetPreviewBtnObj(2)
        this.savePreviewPicArr.push(themeItem.dataItemId)
      } else if (themeItem.currPreviewType === 'video') {
        themeItem.videoPreview_loadSuccessBtnObj = this.initSetPreviewBtnObj(2)
        this.savePreviewVideoArr.push(themeItem.dataItemId)
      }
      await https_package_previewPicOrVideo(
        this.axiosBaseUrl,
        this.$axios,
        query,
        {
          // cancelToken: new CancelToken(function executor(c) {
          //   // 参数 c 也是个函数
          //   _this.cancelToken.push(c)
          // }),
          cancelToken: this.axiosCancelSource.token,
          timeout: this.apiTimeOutMinNum * 60 * 1000, //重设请求超时时间
        }
      )
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            this.updatePreviewPicOrVideo(themeItem.currPreviewType, res.data)
            let typeText = themeItem.currPreviewType === 'pic' ? '图片' : '视频'
            let statusText = ''
            if (res.data.createStatus && res.data.createStatus === 2) {
              statusText = '合成中'
            } else if (res.data.createStatus && res.data.createStatus === 3) {
              statusText = '合成完成'
            }
            if (statusText) {
              this.$message({
                showClose: true,
                message: `【${themeItem.dataItemName}】-${typeText}${statusText}`,
                type: 'success',
              })
            }
            this.initRefreshEvent()
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
          // if (this.isCancel(err)) {
          //   // 获取 取消请求 的相关信息
          //   console.debug('Request canceled', thrown.message)
          // } else {
          //   // 处理其他异常
          // }
        })
    },
    updatePushMaterialsItem(type, resData) {
      if (type === 'pic') {
        let newSavePushMaterialsPicArr = []
        this.savePushMaterialsPicArr.forEach((dataItemId) => {
          if (dataItemId !== resData.dataItemId) {
            newSavePushMaterialsPicArr.push(dataItemId)
          } else {
            this.themeList.forEach((themeItem) => {
              if (themeItem.dataItemId === dataItemId) {
                themeItem.pictures = resData.list
                themeItem.pictureCreateStatus = resData.createStatus
                themeItem.pic_loadSuccessBtnObj =
                  this.computedPic_loadSuccessBtnObj(themeItem)
              }
            })
          }
        })
        this.savePushMaterialsPicArr = newSavePushMaterialsPicArr
      } else if (type === 'video') {
        console.debug('updatePushMaterialsItem', this.savePreviewVideoArr)
        let newSavePushMaterialsVideoArr = []
        this.savePushMaterialsVideoArr.forEach((dataItemId) => {
          if (dataItemId !== resData.dataItemId) {
            newSavePushMaterialsVideoArr.push(dataItemId)
          } else {
            this.themeList.forEach((themeItem) => {
              console.debug('updatePushMaterialsItem:', themeItem)
              if (themeItem.dataItemId === dataItemId) {
                themeItem.videos = resData.list
                themeItem.videoCreateStatus = resData.createStatus
                themeItem.video_loadSuccessBtnObj =
                  this.computedVideo_loadSuccessBtnObj(themeItem)
              }
            })
          }
        })
        this.savePushMaterialsVideoArr = newSavePushMaterialsVideoArr
      }
    },
    updatePreviewPicOrVideo(type, resData) {
      console.debug('updatePreviewPicOrVideo', type, resData)
      if (type === 'pic') {
        let newSavePreviewPicArr = []
        this.savePreviewPicArr.forEach((dataItemId) => {
          if (dataItemId !== resData.dataItemId) {
            newSavePreviewPicArr.push(dataItemId)
          } else {
            this.themeList.forEach((themeItem) => {
              if (themeItem.dataItemId === dataItemId) {
                if (resData.list && resData.list.length > 0) {
                  themeItem.pictures = resData.list
                }
                themeItem.pictureCreateStatus = resData.createStatus
                themeItem.picPreview_loadSuccessBtnObj =
                  this.initSetPreviewBtnObj(resData.createStatus)
                themeItem.pic_loadSuccessBtnObj =
                  this.computedPic_loadSuccessBtnObj(themeItem)
              }
            })
          }
        })
        this.savePreviewPicArr = newSavePreviewPicArr
      } else if (type === 'video') {
        console.debug('updatePreviewPicOrVideo', this.savePreviewVideoArr)
        let newSavePreviewVideoArr = []
        this.savePreviewVideoArr.forEach((dataItemId) => {
          if (dataItemId !== resData.dataItemId) {
            newSavePreviewVideoArr.push(dataItemId)
          } else {
            this.themeList.forEach((themeItem) => {
              console.debug('updatePreviewPicOrVideo:', themeItem)
              if (themeItem.dataItemId === dataItemId) {
                if (resData.list && resData.list.length > 0) {
                  themeItem.videos = resData.list
                }
                themeItem.videoCreateStatus = resData.createStatus
                themeItem.videoPreview_loadSuccessBtnObj =
                  this.initSetPreviewBtnObj(resData.createStatus)
                themeItem.video_loadSuccessBtnObj =
                  this.computedVideo_loadSuccessBtnObj(themeItem)
              }
            })
          }
        })
        this.savePreviewVideoArr = newSavePreviewVideoArr
      }
    },
    initSetPreviewBtnObj(state) {
      // 【合成】 按钮的状态
      let loadSuccessBtnObj = null
      if (state === 1) {
        // 未推送过 可点击
        loadSuccessBtnObj = {
          btnType: 'start',
          loading: false,
          disabled: false,
          success: false,
          error: false,
          isShowTextIcon: 0,
        }
      } else if (state === 2) {
        // 推送中
        loadSuccessBtnObj = {
          btnType: 'playing',
          loading: true,
          disabled: false,
          success: false,
          error: false,
          isShowTextIcon: 0,
        }
      } else if (state === 3) {
        // 推送成功结果 || 推送【推送成功过】
        loadSuccessBtnObj = {
          btnType: 'start',
          loading: false,
          disabled: false,
          success: false,
          error: false,
          isShowTextIcon: 0,
        }
      } else if (state === 6) {
        // 刚推送完成时，动画中成功
        loadSuccessBtnObj = {
          btnType: 'playing',
          loading: false,
          disabled: false,
          success: true,
          error: false,
          isShowTextIcon: 0,
        }
      } else {
      }
      return loadSuccessBtnObj
    },
    initSetPushBtnObj(state) {
      let loadSuccessBtnObj = null
      if (state === 1) {
        // 未推送过 可点击
        loadSuccessBtnObj = {
          btnType: 'start',
          loading: false,
          disabled: false,
          success: false,
          error: false,
          isShowTextIcon: 0,
        }
      } else if (state === 2) {
        // 推送中
        loadSuccessBtnObj = {
          btnType: 'playing',
          loading: true,
          disabled: false,
          success: false,
          error: false,
          isShowTextIcon: 0,
        }
      } else if (state === 3) {
        // 推送成功结果 || 推送【推送成功过】
        loadSuccessBtnObj = {
          btnType: 'start',
          loading: false,
          disabled: false,
          success: false,
          error: false,
          isShowTextIcon: 1,
        }
      } else if (state === 4) {
        // 推送失败
        loadSuccessBtnObj = {
          btnType: 'start',
          loading: false,
          disabled: false,
          success: false,
          error: false,
          isShowTextIcon: 2,
        }
      } else if (state === 5) {
        // 未推送过  不可点击 【因为没有合成过，因此不能点击】
        loadSuccessBtnObj = {
          btnType: 'start',
          loading: false,
          disabled: true,
          success: false,
          error: false,
          isShowTextIcon: 0,
        }
      } else if (state === 6) {
        // 刚推送完成时，动画中成功
        loadSuccessBtnObj = {
          btnType: 'playing',
          loading: false,
          disabled: false,
          success: true,
          error: false,
          isShowTextIcon: 0,
        }
      } else if (state === 7) {
        // 刚推送完成时，动画中失败
        loadSuccessBtnObj = {
          btnType: 'playing',
          loading: false,
          disabled: false,
          success: false,
          error: true,
          isShowTextIcon: 0,
        }
      } else {
      }
      return loadSuccessBtnObj
    },
    computedPic_loadSuccessBtnObj(item) {
      let pic_loadSuccessBtnObj = null
      if (item.picturePushStatus === 1) {
        // 未推送过
        if (
          (item.pictures && item.pictures.length > 1) ||
          item.pictureCreateStatus === 3
        ) {
          // 已经合成过图片；可以推送
          // pictures数组个数大于1，肯定之前合成过；如果pictures数组等于1则判断 pictureCreateStatus 字段
          // pictureCreateStatus： 1：未合成， 2：合成中，3：合成过（肯定会成功）
          pic_loadSuccessBtnObj = this.initSetPushBtnObj(1)
        } else {
          // 未合成过图片或者合成中，需要先合成才能推送；不可以推送
          pic_loadSuccessBtnObj = this.initSetPushBtnObj(5)
        }
      } else if (item.picturePushStatus === 2) {
        // 推送中
        pic_loadSuccessBtnObj = this.initSetPushBtnObj(2)
      } else if (item.picturePushStatus === 3) {
        // 推送成功, 因此【推送】+ 成功图标
        pic_loadSuccessBtnObj = this.initSetPushBtnObj(3)
      } else if (item.picturePushStatus === 4) {
        // 推送失败, 因此【推送】+ 失败图标
        pic_loadSuccessBtnObj = this.initSetPushBtnObj(4)
      } else {
        // 错误状态
        pic_loadSuccessBtnObj = null
      }
      return pic_loadSuccessBtnObj
    },
    computedVideo_loadSuccessBtnObj(item) {
      let video_loadSuccessBtnObj = null
      if (item.videoPushStatus === 1) {
        // 未推送过
        if (item.videoCreateStatus === 3) {
          // 已经合成过视频；可以推送
          // videos 数组个数大于0，肯定之前合成过；如果 videos 数组等于0则判断 videoCreateStatus 字段
          // videoCreateStatus 1：未合成， 2：合成中，3：合成过（肯定会成功）
          video_loadSuccessBtnObj = this.initSetPushBtnObj(1)
        } else {
          // 未合成过视频，需要先合成才能推送；不可推送
          video_loadSuccessBtnObj = this.initSetPushBtnObj(5)
        }
      } else if (item.videoPushStatus === 2) {
        // 推送中
        video_loadSuccessBtnObj = this.initSetPushBtnObj(2)
      } else if (item.videoPushStatus === 3) {
        // 推送成功, 因此【推送】+ 成功图标
        video_loadSuccessBtnObj = this.initSetPushBtnObj(3)
      } else if (item.videoPushStatus === 4) {
        // 推送失败, 因此【推送】+ 失败图标
        video_loadSuccessBtnObj = this.initSetPushBtnObj(4)
      } else {
        // 错误状态
        video_loadSuccessBtnObj = null
      }
      return video_loadSuccessBtnObj
    },
    allThemeRenderHandler(list) {
      // 所有主题的数据处理在这里统一进行
      console.debug('处理主题数据:', list)
      return list.map((item) => {
        item.analysisItemName = item.dataItemName
        item.renderData = item.dataSearchResultModel
        item.isChooseAct = false //是否选中多选按钮
        if (!item.currPreviewType) {
          item.currPreviewType = this.initCurrPreviewType
        }
        // 【合成】按钮状态
        item.picPreview_loadSuccessBtnObj = this.initSetPreviewBtnObj(
          item.pictureCreateStatus
        )
        item.videoPreview_loadSuccessBtnObj = this.initSetPreviewBtnObj(
          item.videoCreateStatus
        )

        item.pic_loadSuccessBtnObj = this.computedPic_loadSuccessBtnObj(item)
        item.video_loadSuccessBtnObj =
          this.computedVideo_loadSuccessBtnObj(item)
        console.debug(item)
        if (!item.isMediaBroadcastFlag) {
          item.isMediaBroadcastFlag = this.isMediaBroadcastFlag
        }

        if (item.analysisItemStyles && item.analysisItemStyles[0]) {
          const styleItem = item.analysisItemStyles[0]
          item.title2RightName = styleItem.styleName
            ? `风格：${styleItem.styleName}`
            : ''
        } else {
          item.title2RightName = ''
        }

        if (this.cardThemeGraphicsIds.includes(item.graphicsId)) {
          let mode = null
          let list = {
            title:
              item.dataSearchResultModel && item.dataSearchResultModel.title
                ? item.dataSearchResultModel.title
                : '',
            key: item.graphicsId,
            datas:
              item.dataSearchResultModel && item.dataSearchResultModel.data
                ? item.dataSearchResultModel.data.dataList.map((item) => {
                    if (!mode) {
                      mode = item.playerId
                        ? 'overviewPlayerData'
                        : 'overviewTeamData'
                    }
                    return {
                      imageUrl: item.playerId ? item.playerLogo : item.teamLogo,
                      id: item.playerId ? item.playerId : item.teamId,
                      shortName: item.playerId
                        ? item.playerName
                        : item.teamName,
                      val: item.num,
                      rank: item.rank,
                    }
                  })
                : [],
          }
          item.list = list
          item.mode = mode
        }
        if (item.graphicsId == 13) {
          const floor1_1 = item.dataSearchResultModel
          let list1_1 = floor1_1.statisticsModels.map((model) => {
            return {
              analysisItemId: model.analysisItemId,
              key: model.statisticalEn,
              name: model.name,
              val: floor1_1.data.dataList[0][model.statisticalEn],
              valWeb: model.suffix
                ? floor1_1.data.dataList[0][model.statisticalEn] + model.suffix
                : floor1_1.data.dataList[0][model.statisticalEn],
              suffix: model.suffix,
            }
          })
          item.renderData = {
            analysisItemId: floor1_1.analysisItemId,
            title: floor1_1.title,
            json: floor1_1.json,
            seasonOrMatch: floor1_1.seasonOrMatch,
            totalObj:
              list1_1.length > 0
                ? list1_1[0]
                : [
                    {
                      name: '',
                      val: '',
                      valWeb: '',
                      suffix: '',
                    },
                  ],
            otherArr: list1_1.length > 1 ? list1_1.slice(1) : [],
          }
          console.debug('13:', item)
        }
        if (item.graphicsId == 14) {
          const floor1_2 = item.dataSearchResultModel
          let maxVal = 0
          let list1_2 = floor1_2.statisticsModels.map((model) => {
            const val = floor1_2.data.dataList[0][model.statisticalEn]
            if (val > maxVal) {
              maxVal = val
            }
            return {
              key: model.statisticalEn,
              name: model.name,
              val,
              suffix: model.suffix,
            }
          })
          if (maxVal > 0) {
            list1_2.forEach((item) => {
              item.valPer = ((item.val / maxVal) * 4.5).toFixed(2)
            })
          }
          item.renderData = {
            analysisItemId: floor1_2.analysisItemId,
            title: floor1_2.title,
            json: floor1_2.json,
            seasonOrMatch: floor1_2.seasonOrMatch,
            barArr: list1_2.length > 0 ? list1_2 : [],
          }
        }
        console.debug('allThemeRenderHandler:', item)
        return item
      })
    },
    async sendPackageItemInfos(baseApi, query, type) {
      //生成播单
      await https_package_sendPackageItemInfos(
        baseApi,
        this.$axios,
        query,
        type
      )
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            this.$message({
              showClose: true,
              message: '播单生成成功',
              type: 'success',
            })
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
    async downItemThemeData(baseApi, query, type) {
      //下载单个主题数据
      await https_package_downItemThemeData(baseApi, this.$axios, query, type)
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            this.$message({
              showClose: true,
              message: '下载成功',
              type: 'success',
            })
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
    async downItemPlayerItemData(baseApi, query, type) {
      //下载某个播出单下所有主题数据
      await https_package_downItemPlayerItemData(
        baseApi,
        this.$axios,
        query,
        type
      )
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            this.$message({
              showClose: true,
              message: '全部下载成功',
              type: 'success',
            })
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
    async daYangPushDataThemeItem(baseApi, type) {
      //获得单个主题数据（大洋）在线包装工作台，获取成功后通过内网推送
      let { packageId, groupId } = this.getSeasonNameAndPackageName()
      let params = {
        dataItemId: this.currItemTheme.dataItemId,
        packageId,
        groupId,
      }
      await this.daYangInsidePushData(baseApi, params, type)
      // await https_package_pushItemThemeDaYang(baseApi, this.$axios, params)
      //   .then((response) => {
      //     const res = response.data
      //     if (res.status === 0) {
      //     } else {
      //       if (res.message) {
      //         // message：null，因此不弹出警示框（一般404 || 500的时候）；
      //         // message不为null的时候展示警示框；
      //         this.$message({
      //           showClose: true,
      //           message: res.message ? res.message : '服务器异常，请稍后再试',
      //           type: 'warning',
      //         })
      //       }
      //     }
      //   })
      //   .catch((err) => {
      //     console.debug(err)
      //   })
    },
    async daYangPushDataPlayerList(baseApi, type) {
      //获取某个播出单全部主题数据（大洋）在线包装工作台，获取成功后通过内网推送
      let { packageId, groupId } = this.getSeasonNameAndPackageName()
      let params = {
        broadcastId: this.currPlayerItemId,
        packageId,
        groupId,
      }
      await this.daYangInsidePushData(baseApi, params, type)
      // await https_package_pushBroadcastDaYang(baseApi, this.$axios, params)
      //   .then((response) => {
      //     const res = response.data
      //     if (res.status === 0) {
      //     } else {
      //       if (res.message) {
      //         // message：null，因此不弹出警示框（一般404 || 500的时候）；
      //         // message不为null的时候展示警示框；
      //         this.$message({
      //           showClose: true,
      //           message: res.message ? res.message : '服务器异常，请稍后再试',
      //           type: 'warning',
      //         })
      //       }
      //     }
      //   })
      //   .catch((err) => {
      //     console.debug(err)
      //   })
    },
    async daYangInsidePushData(baseApi, params, type) {
      // 向大洋内网推送数据
      console.debug('向大洋内网推送数据:', baseApi, type)
      params.url = this.axiosBaseUrl
      params.pushPrefix = this.daYangThemeBtnArr.room[0].pushPrefix
      params.sportType = this.sportCompetitionType.split('_')[0]
      await https_package_inSidePushDataDaYang(
        baseApi,
        this.$axios,
        params,
        type
      )
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            this.$message({
              showClose: true,
              message: '推送成功',
              type: 'success',
            })
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
    async removeRoomPackageItems(item, type) {
      //删除某个演播室下单个主题||多个主题
      const query = {
        dataItemIds:
          type && type === 'batch' ? item.join(',') : item.dataItemId,
        broadcastId: this.currPlayerItemId,
      }
      await https_broadcast_postClearBroadcastItems(
        this.axiosBaseUrl,
        this.$axios,
        query
      )
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            this.$message({
              showClose: true,
              message: '删除成功',
              type: 'success',
            })
            this.cancelBatchChoose_remove()
            this.autoLoadThemeList()
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
    async removeDataPackageItems(item) {
      // 备注，后端时间不够，暂时删除用公共播单的
      //删除媒体云中的单个主题
      const query = {
        dataItemId: item.dataItemId,
        addStatus: false, //这里只是删除，所以写死false
        groupId: this.currGroup.groupId,
        competitionId: this.currCid,
        seasonId: this.currSid,
      }
      await https_package_isAddPublicBroadcastItem(
        this.axiosBaseUrl,
        this.$axios,
        query
      )
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            this.$message({
              showClose: true,
              message: '删除成功',
              type: 'success',
            })
            this.autoLoadThemeList()
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
    async editDataItemName(item) {
      console.debug(item)
      // 文件命名主题标题
      const query = {
        dataItemId: item.dataItemId,
        dataItemName: this.editThemeTitle,
        eventId: item.eventId ? item.eventId : 0,
        seasonId: this.currSid,
      }
      await https_package_changeDataItemName(
        this.axiosBaseUrl,
        this.$axios,
        query
      )
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            this.$message({
              showClose: true,
              message: '修改成功',
              type: 'success',
            })
            this.themeList.forEach((val) => {
              if (val.dataItemId == item.dataItemId) {
                val.analysisItemName = this.editThemeTitle
              }
            })
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
      window.mixtmtBase_eventBus.$emit('loadingEvent', false)
    },
    getSeasonNameAndPackageName() {
      // console.debug(
      //   'getSeasonNameAndPackageName:',
      //   window.mixtmt_platfrom.currGroup
      // )
      return {
        packageName: this.currRoom.name,
        packageId: this.currRoom.id,
        groupName: window.mixtmt_platfrom.currGroup
          ? window.mixtmt_platfrom.currGroup.groupName
          : '',
        groupId: window.mixtmt_platfrom.currGroup
          ? window.mixtmt_platfrom.currGroup.groupId
          : '',
      }
    },
    async produceList() {
      // 生成播单
      console.debug(
        this.currPlayerItemId,
        this.axiosBaseUrl,
        this.currUserObj.id
      )
      let { packageId, groupId } = this.getSeasonNameAndPackageName()
      let params = {
        broadcastIds: this.currPlayerItemId,
        packageId,
        groupId,
      }
      let url = ''
      if (this.currUserObj.id == 'safetyUser') {
        url = this.axiosBaseUrl
      } else if (this.currUserObj.id == 'packageUser') {
        params.url = this.axiosBaseUrl
        url = 'http://127.0.0.1:9029'
        // await axios
        //   .post(`http://127.0.0.1:9029/cdvData/createPlayCard`, params)
        //   .then((response) => {
        //     const res = response.data
        //     if (res.status === 0) {
        //       this.$message({
        //         showClose: true,
        //         message: '播单生成成功',
        //         type: 'success',
        //       })
        //     } else {
        //       // if (res.message) {
        //       //   // message：null，因此不弹出警示框（一般404 || 500的时候）；
        //       //   // message不为null的时候展示警示框；
        //       //   this.$message({
        //       //     showClose: true,
        //       //     message: res.message ? res.message : '服务器异常，请稍后再试',
        //       //     type: 'warning',
        //       //   })
        //       // }
        //       this.$message({
        //         showClose: true,
        //         message: '服务器异常，请稍后再试',
        //         type: 'warning',
        //       })
        //     }
        //   })
        //   .catch((err) => {
        //     console.debug(err)
        //     this.$message({
        //       showClose: true,
        //       message: '服务器异常，请稍后再试',
        //       type: 'warning',
        //     })
        //   })
      }
      console.debug('params:', params, this.axiosBaseUrl)
      await this.sendPackageItemInfos(url, params, this.currUserObj.id)
      window.mixtmtBase_eventBus.$emit('loadingEvent', false)
    },
    async downAllData() {
      // 下载某个播单下所有主题数据
      console.debug(this.currPlayerItemId, this.axiosBaseUrl)
      let { packageId, groupId } = this.getSeasonNameAndPackageName()
      if (this.currUserObj.id == 'safetyUser') {
        let params = {
          broadcastIds: this.currPlayerItemId,
          packageId,
          groupId,
        }
        await this.downItemPlayerItemData(
          this.axiosBaseUrl,
          params,
          this.currUserObj.id
        )
      } else if (this.currUserObj.id == 'packageUser') {
        let params = {
          url: this.axiosBaseUrl,
          broadcastIds: this.currPlayerItemId,
        }
        await this.downItemPlayerItemData(
          'http://127.0.0.1:9029',
          params,
          this.currUserObj.id
        )
      }

      window.mixtmtBase_eventBus.$emit('loadingEvent', false)
    },
    async themeDownData(item) {
      // 下载单个主题数据
      console.debug(this.currPlayerItemId, this.axiosBaseUrl)
      let { packageId, groupId } = this.getSeasonNameAndPackageName()
      if (this.currUserObj.id == 'safetyUser') {
        let params = {
          dataItemId: item.dataItemId,
          packageId,
          groupId,
        }
        await this.downItemThemeData(
          this.axiosBaseUrl,
          params,
          this.currUserObj.id
        )
      } else if (this.currUserObj.id == 'packageUser') {
        let params = {
          url: this.axiosBaseUrl,
          dataItemId: item.dataItemId,
        }
        await this.downItemThemeData(
          'http://127.0.0.1:9029',
          params,
          this.currUserObj.id
        )
      }

      window.mixtmtBase_eventBus.$emit('loadingEvent', false)
    },
    async themeDownPic(item) {
      // 单个主题 下载图片
      console.debug(item, this.$route)
      let query = {
        sportType: item.sportType,
        pathModule: this.$route.meta.pathModule[1],
        cid: item.competitionId,
        sid: item.seasonId,
        dataItemId: item.dataItemId,
        width: item.width,
        height: item.height,
        axiosBaseUrl: this.axiosBaseUrl,
      }
      this.openNewWeb(this.$router, 'autoExportPngIndex', query)
      // window.mixtmtBase_eventBus.$emit('loadingEvent', false)
    },
  },
}
